import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { MDBInput, MDBTextArea, MDBAlert, MDBIcon, MDBBtn, MDBCard, MDBCardBody, MDBCol, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBModalTitle, MDBRow } from 'mdb-react-ui-kit'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import HeroSectionEditor from '../components/HeroSectionEditor';
import PlansEditor from '../components/PlansEditor';
import ContactEditor from '../components/ContactEditor';
import FooterEditor from '../components/FooterEditor';
import { createGymHomePage, getGBussinessInfo, getGymAddonsList, getGymHomePage } from '../../services/apiServices';
import logImg from "../../components/images/Easy-MembrLogo.png";
import selectimg from "../../gymhomepage/assets/images/selectcard.png";
import backdrop from "../assets/images/backdrop.png";
import { getAllSubDomain, getGymPlansList } from '../../services/classApiServices';
import { defaultPageInfo } from '../../utils/defaultPageInfo';
import GymTemplate from '../../views/gymTemplate';
import { useNavigate } from "react-router";
import copy from 'clipboard-copy';

const GymPageEditor = () => {
    const [pageData, setPageData] = useState(defaultPageInfo);
    const [activeSection, setActiveSection] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [editingElement, setEditingElement] = useState(null);
    const [dragState, setDragState] = useState({
        isDragging: false,
        draggableId: null
    });
    const [Alerttxt, setAlerttxt] = useState("");
    const [optSmModal, setOptSmModal] = useState(false)
    const [copyLink, setcopyLink] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        async function fetchData() {
            if (localStorage.getItem("loggedUserInfo")) {
                const response = await getGymHomePage(
                    JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                );
                if (response && response !== "false") {
                    const tempData = await response.json();
                    console.log(tempData);

                    setPageData(tempData);
                }
            }
        }
        fetchData();
    }, []);

    const [membership, setMembership] = useState([])
    const [bussinessInfo, setBusinessinfo] = useState(null)
    const mainDomain = getMainDomain(window.location.hostname);

    useEffect(() => {
        fetchPlansAndAddons();

        async function fetchPlansAndAddons() {
            const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
            if (!userInfo) return;

            let mergedMembership = [];

            const plansResponse = await getGymPlansList(userInfo.gymid);
            if (plansResponse && plansResponse !== "false") {
                const plansData = await plansResponse.json();

                let expandedPlans = [];

                plansData.forEach(plan => {

                    //  CASE 1: Plan has subplans → add ONLY subplans
                    if (Array.isArray(plan.subplans) && plan.subplans.length > 0) {
                        plan.subplans.forEach(subplan => {
                            expandedPlans.push({
                                ...subplan,
                                type: "plan",
                             
                                displayName: `${plan.name}-${subplan.name}`
                            });
                        });
                    }
                    // CASE 2: No subplans → add main plan
                    else {
                        expandedPlans.push({
                            ...plan,
                            type: "plan",
                    
                            displayName: plan.name
                        });
                    }
                });

                mergedMembership = [...mergedMembership, ...expandedPlans];
            }

            const addonsResponse = await getGymAddonsList(userInfo.gymid);
            if (addonsResponse && addonsResponse !== "false") {
                const addonsData = await addonsResponse.json();

                const enabledAddons = addonsData
                    .filter(addon => addon.enable === true)
                    .map(addon => ({ ...addon, type: "addons", displayName: addon.name }));

                mergedMembership = [...mergedMembership, ...enabledAddons];
            }

            setMembership(mergedMembership);
        }
    }, []);


    function getMainDomain(hostname) {
        const parts = hostname.split('.');
        if (parts.length >= 2) {
            return parts.slice(-2).join('.');
        }
        return hostname;
    }


    const [currentdomain, setCurrentdomain] = useState({})
    async function fetchsubDomains() {
        const gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
        // const url = new URL("https://easymembr.com/classesbusiness");
        // const url = new URL("https://zencruz.com/classesbusiness")
        // const hostname = url.hostname;

        // const Domain = getMainDomain(hostname);
        const Domain = getMainDomain(window.location.hostname);
        const subDomainInfo = await getAllSubDomain(Domain);
        if (!subDomainInfo || subDomainInfo === "false") return;

        const subDomainData = await subDomainInfo.json();
        console.log(subDomainData, '999999999999999999999');
        // setSubDomainData(subDomainData);


        const matchedDomain = subDomainData?.length > 0 ? subDomainData.find((item) => item.gymid === gymid) : {};
        if (matchedDomain) {
            // setSubdomain(matchedDomain.subdomain)
            setCurrentdomain(matchedDomain);
        } else {
            setCurrentdomain({});
        }
        // setRefresh(false)
    }

    useEffect(() => {
        const fetchData = async () => {
            if (localStorage.getItem("loggedUserInfo")) {
                const response = await getGBussinessInfo(
                    JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                );
                if (!response || response === "false") {
                    return;
                }
                const recinfo = await response.json();
                if (recinfo) {
                    console.log(recinfo, 'recinfo');

                    setBusinessinfo(recinfo)
                }
            }
        }

        fetchData();
        fetchsubDomains()
    }, []);

    const handleShare = async () => {
        try {

            const shareUrl = currentdomain.status == 3 ? `https://${currentdomain.subdomain}.${mainDomain}/` : null;


            if (shareUrl !== null) {
                await navigator.share({
                    title: "testing",
                    // text: [
                    //     `Join me for: ${event.title}`,
                    //     event.extendedProps?.date && `When: ${event.extendedProps.date}`,
                    //     event.extendedProps?.location && `Where: ${event.extendedProps.location}`,
                    //     event.extendedProps?.trainer && `Host: ${event.extendedProps.trainer}`,
                    //     event.extendedProps?.description && `Details: ${event.extendedProps.description}`
                    // ].filter(Boolean).join('\n\n'),
                    url: shareUrl
                });
            }
        } catch (err) {
            console.log('Share failed:', err);
        }
    };
    const handlecopyDomainuserUrl = () => {

        const shareUrl = currentdomain.status == 3 ? `https://${currentdomain.subdomain}.${mainDomain}` : null;
        if (shareUrl) {
            copy(shareUrl);
            console.log("Share URL:", shareUrl);
            // copy(shareUrl)
            setcopyLink(true);
        }

    }

    const handleDragStart = (result) => {
        setDragState({
            isDragging: true,
            draggableId: result.draggableId
        });
    };

    const handleDragEnd = (result) => {
        setDragState({
            isDragging: false,
            draggableId: null
        });

        if (!result.destination) return;

        if (result.type === "HERO_SECTIONS") {
            const items = Array.from(pageData.herosections);
            const [reorderedItem] = items.splice(result.source.index, 1);
            items.splice(result.destination.index, 0, reorderedItem);

            const updatedItems = items.map((item, index) => ({
                ...item,
                order: index
            }));

            setPageData({ ...pageData, herosections: updatedItems });
        }
    };

    const handleAddHeroSection = () => {
        const newHero = {
            id: `hero-${Date.now()}`,
            type: 'hero',
            title: "New Hero Section",
            subtitle: "",
            description: "",
            backgroundcolor: "#ffffff",
            heroimage: "",
            layout: "image-right",
            isactive: true,
            order: pageData.herosections.length,
            contentposition: 'left',
            imageposition: 'right',
            button: {
                enabled: true,
                text: "Join Now",
                url: "#",
                color: "#ffffff",
                bgcolor: "#007bff",
                bordercolor: "transparent",
                hoverbgcolor: "#0069d9",
                hovercolor: "#ffffff",
                size: "md",
                borderradius: "4px"
            }
        };

        setPageData({
            ...pageData,
            herosections: [...pageData.herosections, newHero]
        });
        setActiveSection(newHero);
        setIsEditing(true);
    };

    const handleRemoveSection = (sectionId) => {
        if (sectionId.startsWith('hero')) {
            setPageData({
                ...pageData,
                herosections: pageData.herosections.filter(h => h.id !== sectionId)
            });
        }
        setIsEditing(false);
        setActiveSection(null);
        setEditingElement(null);
    };

    const handleSectionChange = (updatedSection) => {
        if (updatedSection.type === 'hero') {
            const updatedherosections = pageData.herosections.map(section =>
                section.id === updatedSection.id ? updatedSection : section
            );
            setPageData({ ...pageData, herosections: updatedherosections });
        } else {
            setPageData({ ...pageData, [updatedSection.type]: updatedSection });
        }
        setActiveSection(updatedSection);
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            const gymid = localStorage.getItem("loggedUserInfo") ?
                JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : -1;
            await createGymHomePage(gymid, pageData);
            setAlerttxt("Your Template Saved Successfully");

        } catch (error) {
            console.error("Error saving page data:", error);
            alert('Failed to save changes');
        }
    };


    const renderHeroSectionPreview = (section) => (
        <div
            className={`hero-preview ${activeSection?.id === section.id ? 'active' : ''} ${dragState.isDragging && dragState.draggableId === section.id ? 'dragging-element' : ''}`}
            style={{
                backgroundColor: section.backgroundcolor,
                opacity: section.isactive ? 1 : 0.6
            }}
            onClick={() => {
                setActiveSection(section);
                setIsEditing(true);
                // Don't reset editingElement here to maintain highlight
            }}
        >
            <MDBBtn
                color="danger"
                size="sm"
                onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveSection(section.id);
                }}
                className='trash-btn'
            >
                <i class="fa-solid fa-trash-can"></i>
            </MDBBtn>

            <div className="d-flex align-items-center"
                style={{
                    flexDirection: section.contentposition === 'left' ? 'row' : 'row-reverse'
                }}
            >
                <div className="hero-content" style={{ flex: 1, padding: '1rem' }}>
                    <div
                        className={`ps-0 ${editingElement === 'subtitle' && activeSection?.id === section.id ? 'element-highlight' : ''}`}
                        dangerouslySetInnerHTML={{ __html: section.subtitle || "--" }}
                    />
                    <div
                        className={`ps-0 ${editingElement === 'title' && activeSection?.id === section.id ? 'element-highlight' : ''}`}
                        dangerouslySetInnerHTML={{ __html: section.title || "--" }}
                    />
                    <div
                        className={`ps-0 ${editingElement === 'description' && activeSection?.id === section.id ? 'element-highlight' : ''}`}
                        dangerouslySetInnerHTML={{ __html: section.description || "--" }}
                    />
                    {section?.button?.enabled && (
                        <button
                            style={{
                                color: section.button.color,
                                backgroundColor: section.button.bgcolor,
                                borderColor: section.button.bordercolor,
                                borderRadius: section.button.borderradius || '4px',
                                padding: section.button.size === 'sm' ? '0.25rem 0.5rem' :
                                    section.button.size === 'lg' ? '0.5rem 1rem' : '0.375rem 0.75rem',
                                fontSize: section.button.size === 'sm' ? '0.875rem' :
                                    section.button.size === 'lg' ? '1.25rem' : '1rem',
                            }}
                            href={section.button.url}
                        >
                            {section.button.text}
                        </button>
                    )}
                </div>
                <div className="hero-image" style={{ flex: 1, padding: '1rem' }}>
                    {section.heroimage ? (
                        <img
                            src={section.heroimage}
                            alt="Hero"
                            style={{
                                width: '100%',
                                height: 'auto',
                                borderRadius: '8px',
                            }}
                        />
                    ) : (
                        <div style={{
                            backgroundColor: '#f0f0f0',
                            height: '200px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '8px',
                            border: '2px dashed #cbcbcb'
                        }}>
                            <span>Hero Image</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

    const updatePricing = (planid) => {
        const plandetails = membership.length > 0 ? membership.find((item) => item._id === planid) : {}
        console.log(plandetails, 'plandetails')

        return (plandetails?.price || 0).toLocaleString('en-IN')

    }
    console.log(editingElement, 'editingElement')

    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef(null);
    const intervalRef = useRef(null);

    // Auto-scroll functionality
    useEffect(() => {
        const startAutoScroll = () => {
            intervalRef.current = setInterval(() => {
                setCurrentSlide(prev => (prev + 1) % pageData.plans.items.length);
            }, 3000); // Change slide every 3 seconds
        };

        startAutoScroll();
        return () => clearInterval(intervalRef.current);
    }, [pageData?.plans?.items?.length]);

    // Handle manual slide change
    const goToSlide = (index) => {
        setCurrentSlide(index);
        clearInterval(intervalRef.current);
        intervalRef.current = setInterval(() => {
            setCurrentSlide(prev => (prev + 1) % pageData.plans.items.length);
        }, 3000);
    };

    const nextSlide = () => {
        goToSlide((currentSlide + 1) % pageData.plans.items.length);
    };

    const prevSlide = () => {
        goToSlide((currentSlide - 1 + pageData.plans.items.length) % pageData.plans.items.length);
    };

    const renderPlansPreview = () => {
        return (
            <div
                className={`section-preview ${activeSection?.type === 'plans' ? 'active' : ''}`}
                style={{
                    opacity: pageData?.plans?.isactive ? 1 : 0.6,
                    position: 'relative',
                    backgroundColor: pageData?.plans?.backgroundcolor || "#ffffff"
                }}
                onClick={() => {
                    setActiveSection(pageData?.plans);
                    setIsEditing(true);
                    setEditingElement(null);
                }}
            >
                <div className='container'>
                    <div className='sectionheader text-center mb-5'>
                        <label style={{
                            color: '#7b5cfa',
                            fontSize: '16px',
                            fontWeight: '600',
                            display: 'block',
                            marginBottom: '8px'
                        }}>
                            <div
                                className={`ps-0 ${editingElement === 'subtitle' && activeSection?.type === 'plans' ? 'element-highlight' : ''}`}
                                dangerouslySetInnerHTML={{ __html: pageData?.plans?.subtitle || "Get plans" }}
                            />
                        </label>
                        <h4 style={{
                            fontSize: '32px',
                            fontWeight: '700',
                            margin: 0
                        }}>
                            <div
                                className={`ps-0 ${editingElement === 'title' && activeSection?.type === 'plans' ? 'element-highlight' : ''}`}
                                dangerouslySetInnerHTML={{ __html: pageData?.plans?.title || "Membership plans" }}
                            />
                        </h4>
                    </div>

                    <div className="position-relative">
                        {/* Navigation arrows with MDBIcons */}
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                prevSlide();
                            }}
                            className="slider-arrow slider-arrow-left"
                        >
                            <MDBIcon fas icon="chevron-left" />
                        </button>

                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                nextSlide();
                            }}
                            className="slider-arrow slider-arrow-right"
                        >
                            <MDBIcon fas icon="chevron-right" />
                        </button>

                        {/* Slider container */}
                        <div
                            ref={sliderRef}
                            className="slider-container"
                            style={{
                                display: 'flex',
                                overflow: 'hidden',
                                position: 'relative',
                                width: '100%'
                            }}
                        >
                            <div
                                className="slider-track"
                                style={{
                                    display: 'flex',
                                    transition: 'transform 0.5s ease',
                                    transform: `translateX(-${currentSlide * (100 / 3)}%)`, // Show 3 cards at a time
                                    width: `${100 * pageData.plans.items.length / 3}%`
                                }}
                            >
                                {pageData.plans.items.map((plan, index) => {
                                    const themeColor = plan.themecolor || '#007bff';
                                    const buttonHoverColor = plan.themecolor ? `${plan.themecolor}90` : '#0069d9';

                                    return (
                                        <div
                                            key={plan.id}
                                            className="slider-slide"
                                            style={{
                                                flex: '0 0 33.333%',
                                                padding: '0 15px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            <MDBCard
                                                className='h-100'
                                                style={{
                                                    border: `2px solid ${themeColor}`,
                                                    transition: 'all 0.3s ease'
                                                }}
                                            >
                                                {plan.ispopular && (
                                                    <div
                                                        className="popular-badge"
                                                        style={{
                                                            backgroundColor: plan.themecolor || '#007bff'
                                                        }}
                                                    >
                                                        {plan.tagtext || "POPULAR"}
                                                    </div>
                                                )}
                                                <MDBCardBody className='d-flex flex-column h-100'>
                                                    <div className='planheader'>
                                                        <div
                                                            className='plan_icon'
                                                            style={{
                                                                backgroundColor: themeColor,
                                                                color: '#ffffff'
                                                            }}
                                                        >
                                                            {/* <i className={
                                                                index === 0 ? 'fas fa-tag' :
                                                                    index === 1 ? 'fas fa-rocket' :
                                                                        'fas fa-crown'
                                                            }></i> */}
                                                            <MDBIcon icon={plan.icon} size="lg" />
                                                        </div>
                                                        <div
                                                            className={`plan_title ${editingElement === `plan-${index}-planid` ? 'element-highlight' : ''}`}
                                                        >
                                                            <h4 className='m-0'>{plan.name}</h4>
                                                        </div>
                                                    </div>

                                                    <div className='planbody mt-3 h-100'>
                                                        <ul className='planulist p-0'>
                                                            {plan.features.map((feature, i) => (
                                                                <li
                                                                    key={i}
                                                                    className={editingElement === `plan-${index}-feature-${i}` ? 'planList element-highlight' : 'planList'}
                                                                >
                                                                    <span className='check-list' style={{ background: themeColor }}>
                                                                        <i className="fas fa-check"></i>
                                                                    </span>
                                                                    {feature}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>

                                                    <div className='plan_footer mt-2'>
                                                        <div className='plan_price'>
                                                            <div className='d-flex justify-content-center'>
                                                                <span className='fs-6 me-1 text-secondary'>₹</span>
                                                                <div className='pricePlan'>
                                                                    <h3 className='m-0'>{plan.planid ?
                                                                        updatePricing(plan?.planid)
                                                                        : "0"}</h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <button
                                                            className={`btnn btn-plan hover-filled-slide-down w-100 mt-4 ${editingElement === `plan-${index}-btntext` ? 'element-highlight' : ''}`}
                                                            style={{
                                                                backgroundColor: themeColor,
                                                            }}
                                                        >
                                                            <span>{plan?.btntext ? plan.btntext : "Choose Plan"}</span>
                                                        </button>
                                                    </div>
                                                </MDBCardBody>
                                            </MDBCard>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    {/* Slide indicators */}
                    <div className="slider-indicators" style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '20px'
                    }}>
                        {pageData.plans.items.map((_, index) => (
                            <button
                                key={index}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    goToSlide(index);
                                }}
                                style={{
                                    width: '12px',
                                    height: '12px',
                                    borderRadius: '50%',
                                    border: 'none',
                                    margin: '0 5px',
                                    backgroundColor: currentSlide === index ? '#7b5cfa' : '#ccc',
                                    cursor: 'pointer'
                                }}
                            />
                        ))}
                    </div>
                </div>

                {/* Backdrop elements */}
                <div className='backdrop elemt1'>
                    <img src={backdrop} alt="" />
                </div>
                <div className='backdrop elemt2'>
                    <img src={backdrop} alt="" />
                </div>
            </div>
        );
    };

    const renderContactPreview = () => (
        <div
            className={`contact-preview ${activeSection?.type === 'contact' ? 'active' : ''}`}
            style={{
                opacity: pageData.contact.isactive ? 1 : 0.6,
                backgroundColor: pageData.contact.backgroundcolor
            }}
            onClick={() => {
                setActiveSection(pageData.contact);
                setIsEditing(true);
                setEditingElement(null);
            }}
        >
            <div className='container p-3' style={{ position: 'relative', zIndex: 2 }}>
                <div className='sectionheader text-center mb-5'>
                    <label style={{
                        color: '#7b5cfa',
                        fontSize: '16px',
                        fontWeight: '600',
                        display: 'block',
                        marginBottom: '8px'
                    }}>
                        <div
                            className={`ps-0 ${editingElement === 'subtitle' && activeSection?.type === 'contact' ? 'element-highlight' : ''}`}
                            dangerouslySetInnerHTML={{ __html: pageData.contact.subtitle || "Get in touch" }}
                        />
                    </label>
                    <h4 style={{
                        fontSize: '32px',
                        fontWeight: '700',
                        margin: 0
                    }}>
                        <div
                            className={`ps-0 ${editingElement === 'title' && activeSection?.type === 'contact' ? 'element-highlight' : ''}`}
                            dangerouslySetInnerHTML={{ __html: pageData.contact.title || "Contact with us for more" }}
                        />
                    </h4>
                </div>

                <MDBRow className='align-items-center'>
                    <MDBCol
                        sm={12}
                        md={5}
                        className='mb-4 mb-md-0'
                        style={{
                            flex: 1,
                            padding: '1rem',
                            order: pageData.contact.contentposition === 'left' ? 1 : 0 // Changed this line
                        }}
                    >
                        <div className='contact-section' style={{
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '2px dashed #cbcbcb',
                            borderRadius: '7px',
                        }}>
                            {pageData.contact.image ? (
                                <img
                                    src={pageData.contact.image}
                                    alt="Contact"
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        maxHeight: '500px',
                                        objectFit: 'contain',
                                        borderRadius: '12px'
                                    }}
                                />
                            ) : (
                                <div style={{
                                    backgroundColor: '#f0f0f0',
                                    width: '100%',
                                    height: '400px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '12px'
                                }}>
                                    <span style={{ color: '#888' }}>Contact Image</span>
                                </div>
                            )}
                        </div>
                    </MDBCol>
                    <MDBCol
                        sm={12}
                        md={7}
                        style={{
                            order: pageData.contact.contentposition === 'left' ? 0 : 1
                        }}
                    >
                        <MDBCard className='shadow-3' style={{
                            backgroundColor: pageData.contact.cardbackground || '#ffffff'
                        }}>
                            <MDBCardBody>
                                <div className='contact-header text-center mb-3'>
                                    <h5 style={{
                                        fontSize: '18px',
                                        fontWeight: '500',
                                        color: '#555',
                                        margin: 0
                                    }}>
                                        <div
                                            className={`ps-0 ${editingElement === 'description' && activeSection?.type === 'contact' ? 'element-highlight' : ''}`}
                                            dangerouslySetInnerHTML={{ __html: pageData.contact.description || "We'd love to hear from you! <br />Let's get in touch" }}
                                        />
                                    </h5>
                                </div>
                                <div className='px-3 py-4 bg-white rounded-5'>
                                    <MDBRow>
                                        <MDBCol sm={12} md={6}>
                                            <div className='mb-4'>
                                                <MDBInput
                                                    label="First Name"
                                                    id="formControlLg"
                                                    type="text"
                                                    size="lg"
                                                    disabled
                                                />
                                            </div>
                                        </MDBCol>
                                        <MDBCol sm={12} md={6}>
                                            <div className='mb-4'>
                                                <MDBInput
                                                    label="Last Name"
                                                    id="formControlLg"
                                                    type="text"
                                                    size="lg"
                                                    disabled
                                                />
                                            </div>
                                        </MDBCol>
                                        <MDBCol sm={12} md={6}>
                                            <div className='mb-4'>
                                                <MDBInput
                                                    label="Mobile No"
                                                    id="formControlLg"
                                                    type="number"
                                                    size="lg"
                                                    disabled
                                                />
                                            </div>
                                        </MDBCol>
                                        <MDBCol sm={12} md={6}>
                                            <div className='mb-4'>
                                                <MDBInput
                                                    label="E-mail id"
                                                    id="formControlLg"
                                                    type="text"
                                                    size="lg"
                                                    disabled
                                                />
                                            </div>
                                        </MDBCol>
                                        <MDBCol sm={12} md={12}>
                                            <div className='mb-4'>
                                                <MDBTextArea
                                                    label="Message"
                                                    id="textAreaExample"
                                                    rows={7}
                                                    disabled
                                                />
                                            </div>
                                        </MDBCol>
                                        <MDBCol sm={12} md={12} className='d-flex justify-content-end'>
                                            <button
                                                className="btnn hover-filled-slide-down"
                                                style={{
                                                    backgroundColor: pageData.contact.button?.bgcolor || '#7b5cfa',
                                                    color: pageData.contact.button?.color || '#ffffff',
                                                    border: pageData.contact.button?.bordercolor,
                                                }}
                                            >
                                                <span>{pageData.contact.button?.text || 'Send Message'}</span>
                                            </button>
                                        </MDBCol>
                                    </MDBRow>
                                </div>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                </MDBRow>
            </div>

            {/* Backdrop element */}

        </div>
    );


    const renderFooterPreview = () => (
        <div
            className={`footer-preview ${activeSection?.type === 'footer' ? 'active' : ''}`}
            style={{
                opacity: pageData.footer.isactive ? 1 : 0.6,
                backgroundColor: pageData?.footer?.backgroundcolor || '#2c3e50',
                color: pageData?.footer?.color || 'white',
                padding: '40px 0',
                marginTop: '40px'
            }}
            onClick={() => {
                setActiveSection(pageData.footer);
                setIsEditing(true);
                setEditingElement(null);
            }}
        >
            <div className='container'>
                <MDBRow>
                    {/* Address Column */}
                    <MDBCol sm={12} md={5} className='mb-4 mb-md-0'>
                        <div className='footer-address'>
                            <img
                                src={bussinessInfo?.logourl ? bussinessInfo?.logourl : logImg}
                                alt="Company Logo"
                                style={{
                                    height: '40px',
                                    marginBottom: '20px'
                                }}
                            />
                            <div className='d-flex align-items-center mt-2'>
                                <div className='fs-2 me-3' style={{ color: 'rgba(255,255,255,0.5)' }}>
                                    <i className="fas fa-map-marker-alt"></i>
                                </div>
                                <div>
                                    <p className='m-0' style={{ lineHeight: '1.6' }}>
                                        {/* Sundaralah Vayasra Kondran, Survey No 91,<br />
                                        Gordaland Rd, Madhavu Reddy County,<br />
                                        Gordaland, Hyderabad, Tidrapans 600002 */}
                                        {[
                                            bussinessInfo?.address,
                                            bussinessInfo?.city,
                                            bussinessInfo?.state,
                                            bussinessInfo?.country
                                        ].filter(Boolean).join(", ")}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </MDBCol>

                    {/* Contact Column */}
                    <MDBCol sm={12} md={3} className='mb-4 mb-md-0'>
                        <div>
                            <h4 className='contact-titlename' style={{
                                fontSize: '18px',
                                fontWeight: '600',
                                marginBottom: '20px'
                            }}>
                                Contact Us
                            </h4>
                        </div>
                        <div>
                            <ul className='footer-ul' style={{ listStyle: 'none', padding: 0 }}>
                                <li className='footer-list mb-2'>
                                    <i className="fas fa-phone-alt" style={{
                                        color: 'rgba(255,255,255,0.5)',
                                        marginRight: '10px'
                                    }}></i>
                                    <a href="tel:+918015296362" style={{ color: 'white' }}>{bussinessInfo?.contactNumber
                                        ? bussinessInfo?.contactNumber
                                        : "+918015296362"}</a>
                                </li>
                                <li className='footer-list'>
                                    <i className="fas fa-envelope" style={{
                                        color: 'rgba(255,255,255,0.5)',
                                        marginRight: '10px'
                                    }}></i>
                                    <a href={`mailto:${bussinessInfo?.businessEmail ? bussinessInfo?.businessEmail : "sales@easymembc.com"}`} style={{ color: 'white' }}>{bussinessInfo?.businessEmail
                                        ? bussinessInfo?.businessEmail
                                        :
                                        "sales@easymembc.com"}</a>
                                </li>
                            </ul>
                        </div>
                    </MDBCol>

                    {/* Company Column */}
                    <MDBCol sm={12} md={4} className='mb-4 mb-md-0'>
                        <div>
                            <h4 className='contact-titlename' style={{
                                fontSize: '18px',
                                fontWeight: '600',
                                marginBottom: '20px'
                            }}>
                                Company
                            </h4>
                        </div>
                        <div>

                            <ul className='footer-ul'>
                                <li className='footer-list'><i class="fas fa-shield-alt opacity-50"></i> <span className='ms-2'><a href=""> Privacy policy</a> </span></li>
                                <li className='footer-list'><i class="fas fa-ban opacity-50"></i><span className='ms-2'> <a href=""> Terms and Conditions</a></span></li>
                                <li className='footer-list'> </li>
                            </ul>

                        </div>
                    </MDBCol>

                    {/* Follow Us Section */}
                    <MDBCol sm={12} md={12} className='mt-4'>
                        <div className='social-title text-center'>
                            <h5 style={{
                                position: 'relative',
                                display: 'inline-block',
                                marginBottom: '20px'
                            }}>
                                <span style={{
                                    padding: '5px 15px',
                                    borderRadius: '4px',
                                    backgroundColor: pageData?.footer?.backgroundcolor
                                }}>
                                    Follow us
                                </span>
                                <span style={{
                                    display: 'block',
                                    height: '1px',
                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                    marginTop: '10px'
                                }}></span>
                            </h5>
                        </div>
                    </MDBCol>

                    {/* Social Media Icons */}
                    <MDBCol sm={12} md={12}>
                        <div className='social-media text-center'>
                            {pageData?.footer?.links
                                ?.filter(link => typeof link === 'object' && link.check && link.label)
                                .map((link, index) => {
                                    const iconMap = {
                                        facebook: 'facebook-f',
                                        twitter: 'twitter',
                                        youtube: 'youtube',
                                        whatsapp: 'whatsapp',
                                        instagram: 'instagram',
                                        linkedin: 'linkedin-in'
                                    };

                                    const icon = iconMap[link.label.toLowerCase()] || link.label.toLowerCase();
                                    const isEditing = editingElement === `social-${link.label.toLowerCase()}`;
                                    return (
                                        <a
                                            key={index}
                                            href={link.url || '#'}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className='mx-2 '
                                            style={{
                                                color: 'white',
                                                backgroundColor: isEditing ? 'rgba(255,0,0,0.2)' : 'rgba(255,255,255,0.1)',

                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                textDecoration: 'none',
                                                transition: 'all 0.3s ease'
                                            }}
                                        >
                                            <i className={`fab fa-${icon}`}></i>
                                        </a>
                                    );
                                })}
                        </div>
                    </MDBCol>

                    {/* Copyright Section */}
                    <MDBCol sm={12} className='mt-4 text-center'>
                        <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '0' }}>
                            {pageData?.footer?.content || "© 2023 Fitness Gym. All rights reserved."}
                        </p>
                    </MDBCol>
                </MDBRow>
            </div>
        </div>
    );


    const renderEditor = () => {
        if (!activeSection) return null;
        console.log(activeSection, 'activeSection');

        const gymid = localStorage.getItem("loggedUserInfo") ?
            JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : -1;
        switch (activeSection.type) {
            case 'hero':
                return <HeroSectionEditor
                    key={activeSection.id}
                    section={activeSection}
                    onChange={handleSectionChange}
                    setEditingElement={setEditingElement}
                    editingElement={editingElement}
                    Gid={gymid}
                />;
            case 'plans':
                return <PlansEditor
                    section={activeSection}
                    onChange={handleSectionChange}
                    setEditingElement={setEditingElement}
                    editingElement={editingElement}
                    Gid={gymid}
                    membership={membership}
                />;
            case 'contact':
                return <ContactEditor
                    section={activeSection}
                    onChange={handleSectionChange}
                    setEditingElement={setEditingElement}
                    editingElement={editingElement}
                    Gid={gymid}
                />;
            case 'footer':
                return <FooterEditor
                    section={activeSection}
                    onChange={handleSectionChange}
                    setEditingElement={setEditingElement}
                    editingElement={editingElement}
                    Gid={gymid}
                />;
            default:
                return null;
        }
    };

    const handleExistEditor = () => {
        navigate("/gymtemplate");
    }
    return (
        <Container fluid className="gym-page-editor">
            <style>{`
                .element-highlight {
                    outline: 2px dashed #0d6efd !important;
                    padding: 4px;
                    transition: all 0.2s;
                    animation: pulse 1.5s infinite;
                    position: relative;
                }
                @keyframes pulse {
                    0% { outline-color: #0d6efd; }
                    50% { outline-color: #6ea8fe; }
                    100% { outline-color: #0d6efd; }
                }
                .hero-preview {
                    padding: 1rem;
                    cursor: pointer;
                    position: relative;
                    transition: all 0.2s;
                    border: 1px solid #dee2e6;
                    border-radius: 0.25rem;
                    margin-bottom: 18px;
                }
                .hero-preview:hover {
                    border-color: #adb5bd;
                }
                .hero-preview.active {
                    border: 2px solid #0d6efd !important;
                    box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
                }
            `}</style>
            <div className='edit-container'>
                <div className='edit-header'>
                    <div className='editheader-left d-flex align-items-center'>
                        <h6 className='m-0' onClick={() => { handleExistEditor() }}> <i class="fas fa-sign-out-alt me-1"></i> Exit editor</h6>
                        <h5 className='m-0 border-left border-dark ps-3 ms-2'>Creat Your Template</h5>
                    </div>
                    <div className='editheader-right d-flex align-items-center'>
                        <MDBBtn className='nav-btn me-2' size='sm' onClick={() => { setOptSmModal(true) }}><span> <i class="fas fa-eye me-1"></i> Preview </span>  </MDBBtn>
                        <MDBBtn className='nav-btnoutline me-2' outline size='sm' onClick={handlecopyDomainuserUrl}
                        ><i class="fas fa-link me-1"></i> Copy link</MDBBtn>
                        <MDBBtn className='nav-btn me-2' size='sm' onClick={handleSave}><span><i class="fas fa-save me-1"></i> Save</span></MDBBtn>
                        {/* <i class="fas fa-question-circle fs-6 text-secondary"></i> */}
                    </div>
                </div>
                <div className='h-100 overflow-hidden  mb-1 px-1'>
                    <DragDropContext onDragEnd={handleDragEnd} onDragStart={handleDragStart}>
                        <Row className='h-100'>
                            <Col md={7} className="preview-column h-100 px-3 pe-2">
                                <div className='h-100 d-flex flex-column'>
                                    <div className='d-flex align-items-center justify-content-between templt-title'>
                                        <h5 className="m-0">Template View</h5>
                                        <div>
                                            <MDBBtn className='template-btn' outline size='sm' onClick={handleShare}><i class="fas fa-share me-1"></i> Share</MDBBtn>
                                        </div>
                                    </div>
                                    <div className='h-100 overflow-y-auto overflow-x-hidden pe-1 p-2 bg-white rounded-3'>
                                        <Droppable droppableId="hero-sections" type="HERO_SECTIONS">
                                            {(provided) => (
                                                <Card className='mb-3 shadow-0'>
                                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                                        {pageData.herosections
                                                            .sort((a, b) => a.order - b.order)
                                                            .map((section, index) => (
                                                                <Draggable key={section.id} draggableId={section.id} index={index}>
                                                                    {(provided, snapshot) => (
                                                                        <div
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                            style={{
                                                                                ...provided.draggableProps.style,
                                                                                opacity: snapshot.isDragging ? 0.8 : 1
                                                                            }}
                                                                        >
                                                                            {renderHeroSectionPreview(section)}
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            ))}
                                                        {provided.placeholder}
                                                    </div>
                                                </Card>
                                            )}
                                        </Droppable>

                                        <div className="d-flex justify-content-end align-items-center mb-2">
                                            <MDBBtn className='nav-btn me-2' outline size='sm' onClick={handleAddHeroSection}><span><i class="fa-solid fa-plus me-1"></i>  Add Hero Section</span> </MDBBtn>
                                        </div>


                                        {renderPlansPreview()}
                                        {renderContactPreview()}
                                        {renderFooterPreview()}
                                    </div>
                                </div>
                            </Col>


                            <Col md={5} className="editor-column ps-2 h-100">
                                <div className='bg-white p-3 pt-2 rounded-5 mt-1 h-100 d-flex flex-column'>
                                    <div className="d-flex justify-content-between align-items-center mb-3 pb-2 pt-0 border-bottom templt-title">
                                        <h5 className="mb-0">Template Editor</h5>
                                        {isEditing && (
                                            <MDBBtn className='mx-2 edit-close' color='secondary' onClick={() => {
                                                setIsEditing(false);
                                                setActiveSection(null);
                                                setEditingElement(null);
                                            }} outline floating>
                                                <MDBIcon fas icon='times' />
                                            </MDBBtn>
                                        )}
                                    </div>

                                    {isEditing ? renderEditor() : (
                                        <div className="editor-placeholder text-center">
                                            {/* <i className="bi bi-magic fs-1 mb-3" style={{ opacity: 0.5 }}></i> */}
                                            <img src={selectimg} />
                                            <h5>Select a section to edit</h5>
                                            <p className="text-muted text-center">
                                                Click on any section in the preview to start editing its content and appearance
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </DragDropContext>
                </div>

            </div>

            <MDBAlert
                color="success"
                autohide
                position='top-center'
                delay={2000}
                appendToBody
                open={Alerttxt != ""}
                onClose={() => setAlerttxt("")}
            >
                {Alerttxt}
            </MDBAlert>

            <MDBAlert
                color='success'
                autohide
                position='top-right'
                delay={2000}
                appendToBody
                open={copyLink}
                onClose={() => setcopyLink(false)}
            >Link copied to clipboard!
            </MDBAlert>

            <MDBModal open={optSmModal} tabIndex="-1" onClose={() => setOptSmModal(false)}>
                <MDBModalDialog className='modal-xl'>
                    <MDBModalContent>

                        <MDBModalHeader>
                            <MDBModalTitle>
                                <h6 className="m-0">
                                    Preview Template
                                </h6>
                            </MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={() => setOptSmModal(false)}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <GymTemplate from={"edit"} />
                        </MDBModalBody>
                        {/* <GymHome /> */}

                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </Container >
    );
};

export default GymPageEditor;